import { render, staticRenderFns } from "./PricePerSqm.vue?vue&type=template&id=62d7017a&"
import script from "./PricePerSqm.vue?vue&type=script&lang=ts&"
export * from "./PricePerSqm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports